import { useNavigate } from 'react-router-dom';

export default function useLogout() {
    let navigate = useNavigate();

    const logoutUser = async () => {
        localStorage.removeItem("@App:user");
        localStorage.removeItem("@App:token");
        navigate('/');
    }

    return {
        logoutUser
    }

}